import * as ACTIONS from './../constants'


export const setOffline = () => 
  ({ 
    type: ACTIONS.OFFLINE
  })


export const setOnline = () => 
  ({ 
    type: ACTIONS.ONLINE
  })
